export default "__VITE_ASSET__D7AaYya8__"